import { defineStore } from 'pinia'
import unset from 'lodash.unset';
import services from '@/services';

export const usePreferencesStore = defineStore('preferences', {
  state: () => (
    {
      preferences: undefined,
    }),
  getters: {
  },
  actions: {
    setPreferences(preferences) {
      this.preferences = preferences;
    },
    setPreference(path, preference) {
      services.helpers.set(this.preferences, path, preference);
    },
    deletePreference(path) {
      unset(this.preferences, path);
    }
  },
});
